import React, { ReactNode, useId } from 'react'

import { FaArrowRight } from 'react-icons/fa'

import {
  SectionAction,
  SectionContainer,
  SectionContent,
  SectionHeader,
} from './styles'

type SectionProps = {
  children: ReactNode
  leadingAction?: {
    icon: ReactNode
    label: string
    onClick: () => void
  }
  title: string
  subtitle?: string
} & (
  | { actionLabel: string; onAction: () => void }
  | { actionLabel?: never; onAction?: never }
)

const Section = ({
  actionLabel,
  children,
  leadingAction,
  onAction,
  subtitle,
  title,
}: SectionProps) => {
  const titleId = useId()

  return (
    <SectionContainer aria-labelledby={titleId}>
      <SectionHeader>
        <div className="section-heading">
          {leadingAction && (
            <button
              className="section-leading-action"
              type="button"
              onClick={leadingAction.onClick}
              aria-label={leadingAction.label}
            >
              {leadingAction.icon}
            </button>
          )}
          <div>
            <h2 id={titleId}>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
        </div>
        {actionLabel && (
          <SectionAction type="button" onClick={onAction}>
            {actionLabel} <FaArrowRight aria-hidden="true" />
          </SectionAction>
        )}
      </SectionHeader>
      <SectionContent>{children}</SectionContent>
    </SectionContainer>
  )
}

export default Section
